<template>
  <section class="w100 bg-black white text-left" style="height: 400px;">
    <section class="m-w flex-between font24" style="padding-top:100px;">
      <ul v-for="(i,$i) in lists" :key="$i">
        <li class="normal-lineheight" v-for="(item,$index) in i.list" :key="$i*10+$index">
          <a class="font18 lighter" :href="item.href">{{item.content}}</a>
        </li>
      </ul>
      <div>
        <img src="/static/img/wx.jpg" style="width: 160px;height: 160px;margin-right: 30px;" />
        <img src="/static/img/weibo.png" style="width: 160px;height: 160px;" />
      </div>
    </section>
  </section>
</template>

<script>
  export default {
    data(){
      return {
        lists: [
          {
            list: [
              { content: '智慧小超', href: '' },
              { content: '几禾无人超市', href: '' },
              { content: '购物流程', href: '' },
              { content: '安全保障', href: '' },
              { content: '数据化管理', href: '' },
              { content: '技术支持', href: '' }
            ]
          },
          {
            list: [
              { content: '无人零售', href: '' },
              { content: '供应链', href: '' },
              { content: '城市供应网络', href: '' },
              { content: '快速分销系统', href: '' },
              { content: '多种消费场景', href: '' }
            ]
          },
          {
            list: [
              { content: '合作加盟', href: '' },
              { content: '商业合作', href: '' },
              { content: '楼宇资源合作', href: '' },
              { content: '产品供应合作', href: '' },
              { content: '合作方式', href: '' },
              { content: '加入我们', href: '' }
            ]
          },
          {
            list: [
              { content: '新闻资讯', href: '' },
              { content: '关于我们', href: '' },
              { content: '联系我们', href: '' },
            ]
          }
        ]
      }
    }
  }
</script>

<style scoped>
  ul {
    padding: 0;
    margin: 0;
  }

  ul li {
    list-style: none;
    line-height: .2rem;
  }

  li a {
    color: #ffffff;
  }

  a {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/InnerFooter.vue